import { useStore } from 'effector-react'
import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import SignaturePad from 'react-signature-canvas'
import { $carId } from '~/entities/Inspection/model'
import { Inspection, ThumbType } from '~/shared/api'
import { InspectionPhotoTypeEnum } from '~/shared/config/enums'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { Button } from '~/shared/ui/Buttons'
import { myPalette } from '~/shared/ui/theme'
import { Wrapper } from './styled'

type SignatureProps = {
  onSuccess: (sign: ThumbType) => void
  isSubmitting: boolean
}

const imageType = 'image/jpeg'

export function Signature({ onSuccess, isSubmitting }: SignatureProps) {
  const { t } = useTranslation()
  const padRef = useRef<SignaturePad>(null)
  const carId = useStore($carId) as string
  const [isSignSubmitting, toggleSignSubmitting] = useState<boolean>()

  const handleSuccess = () => {
    const isEmpty = padRef.current?.isEmpty()
    const canvas = padRef.current?.getCanvas()

    if (isEmpty) {
      snackbarEnqueued({
        messageI18n:
          'alert.to complete the inspection, please provide a signature',
        variant: 'warning',
      })
      return
    }

    canvas?.toBlob(async (blob) => {
      try {
        toggleSignSubmitting(true)

        const sign = new File([blob as Blob], 'signature.jpg', {
          type: imageType,
        })
        const resThumb = await Inspection.savePhoto(
          sign,
          carId,
          InspectionPhotoTypeEnum.DRIVER_SIGNATURE,
        )
        onSuccess(resThumb)
      } finally {
        toggleSignSubmitting(false)
      }
    }, imageType)
  }

  return (
    <>
      <Wrapper>
        <SignaturePad
          clearOnResize={false}
          ref={padRef}
          backgroundColor={myPalette.white.main}
          canvasProps={{
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            'data-testid': 'signature-canvas',
          }}
        />
      </Wrapper>

      <Button
        fullWidth
        variant='limeFlooded'
        onClick={handleSuccess}
        loading={isSignSubmitting || isSubmitting}
      >
        {t('button.complete inspection')}
      </Button>
    </>
  )
}
